import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance
const API_FORMDATA = Axios.getInstanceForFormData

export const createIssue = (loginId, data) => {
    const params = { loginId }

    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ISSUE, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getIssueDetails = (pageNumber, pageSize, type, stage, loginId) => {
    const params = { pageNumber, pageSize, type, stage, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ISSUE, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getIssueDashboard = (pageNumber, pageSize, loginId) => {
    const params = { pageNumber, pageSize, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ISSUE_DASHBOARD, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getIssueDetailsById = (issueId, loginId) => {
    const params = { issueId, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ISSUE_BY_ID, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createIssueAnalysis = (data) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ISSUE_ANALYZE, data)
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const createIssuePlanning = (data) => {
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ISSUE_PLANNING, data)
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const createIssueLessonLearnt = (data) => {
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ISSUE_LESSON_LEARNT, data)
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getIssueHistory = (issueId, orgId) => {
    const params = { issueId, orgId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ISSUE_HISTORY, { params })
        .then((response) => response)
}
export const getIssuePeriodicity = (issueId, loginId, orgId) => {
    const params = { issueId, loginId, orgId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ISSUE_PERIODICITY, { params })
        .then((response) => response)
}
export const getIssueSearchHistory = (loginId, filter) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.GET_ISSUE_SEARCH_HISTORY, filter, { params: { loginId } })
        .then((response) => response)
        .catch((err) => ({ err }))
}
